import { render } from "./datagrid-loadpanel-practice.vue?vue&type=template&id=1aebc4b8"
import script from "./datagrid-loadpanel-practice.vue?vue&type=script&lang=js"
export * from "./datagrid-loadpanel-practice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__